import React from 'react';
import { useTranslation } from 'react-i18next';

const ProductDetailHero = () => {
 const { t } = useTranslation();

 return (
 <section className="py-16 lg:py-20 bg-gradient-to-br from-cream-50 via-accent-50/30 to-cream-100 relative overflow-hidden">
 {/* 装饰性背景元素 */}
 <div className="absolute -top-16 -right-16 w-64 h-64 bg-accent-200 rounded-full opacity-10 blur-3xl"></div>
 <div className="absolute top-32 -left-32 w-48 h-48 bg-accent-200 rounded-full opacity-15 blur-2xl"></div>

 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
 <div className="text-center">
 {/* Main Headline */}
 <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-ink-900 mb-6 leading-tight">
 <span className="bg-gradient-to-r from-accent-600 to-accent-500 bg-clip-text text-transparent">
 {t('productDetailHero.headline.part1')}
 </span>
 <br />
 <span className="text-ink-900">
 {t('productDetailHero.headline.part2')}
 </span>
 </h1>

 {/* Subheadline */}
 <p className="text-lg sm:text-xl lg:text-2xl text-ink-600 max-w-4xl mx-auto leading-relaxed">
 {t('productDetailHero.subheadline')}
 </p>
 </div>
 </div>
 </section>
 );
};

export default ProductDetailHero;